import { render, staticRenderFns } from "./HeaderMainMenu.vue?vue&type=template&id=11cdaab4&scoped=true&"
import script from "./HeaderMainMenu.vue?vue&type=script&lang=ts&"
export * from "./HeaderMainMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderMainMenu.vue?vue&type=style&index=0&id=11cdaab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cdaab4",
  null
  
)

/* custom blocks */
import block0 from "./HeaderMainMenu.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports